export default function loadsTranslator(message, dispatch) {
  switch(message.update) {
    case "load created":
    case "load updated":
      dispatch({type: "load/load", load: message.load});
  }
}
